// extracted by mini-css-extract-plugin
export default {"container":"PaginationIndicator_container__EtLvO","dot":"PaginationIndicator_dot__LplUe"};